// extracted by mini-css-extract-plugin
export default {"hero-spacer":"Features_hero-spacer__GfGdv","content-section":"Features_content-section__8ejcR","subt":"Features_subt__MEGk0","subp":"Features_subp__PuzFm"};